export var isNull = function isNull(value) {
  return !value || value === 'null';
};